import { render } from "./hrm-department-modal.vue?vue&type=template&id=5d1b137c"
import script from "./hrm-department-modal.vue?vue&type=script&lang=js"
export * from "./hrm-department-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__